import { CustomComponentProps } from "utils/types/generalTypes";

export type PrivacyItemProps = CustomComponentProps & {
    title: string;
    children: React.ReactNode;
};

const PrivacyItem = ({
    title,
    children,
    className,
    style
}: PrivacyItemProps) => {
    return (
        <div className={`privacy-item ${className} mb-30`} style={style}>
            <h2 className="black-text white-text mb-10">{title}</h2>
            <p className="momeento-p fs-100 light-grey-text">{children}</p>
        </div>
    );
};

export default PrivacyItem;
